/* Cowbell desktop menu (2026-10-10): open a panel when the pointer rests on its label, close it shortly after the
   pointer leaves (hover intent, Baymard/NN/g: a short delay stops panels flickering open as the pointer passes).
   Click, keyboard, Esc and click-outside stay with Dawn (header-menu + global.js). Mouse/trackpad only. */
(() => {
  const canHover = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
  const OPEN_MS = 200, SWITCH_MS = 300, CLOSE_MS = 400;
  const all = () => [...document.querySelectorAll('.cb-dnav__details')];
  const setOpen = (d, open) => {
    d.open = open;
    const s = d.querySelector('summary');
    if (s) s.setAttribute('aria-expanded', String(open));
    if (!open) delete d.dataset.hover;
  };
  all().forEach((d) => {
    const item = d.closest('.cb-dnav__item');
    if (!item) return;
    let timer;
    item.addEventListener('mouseenter', () => {
      if (!canHover.matches) return;
      clearTimeout(timer);
      const other = all().find((o) => o !== d && o.open);
      timer = setTimeout(() => {
        all().forEach((o) => { if (o !== d && o.open) setOpen(o, false); });
        if (!d.open) { setOpen(d, true); d.dataset.hover = '1'; }
      }, other ? SWITCH_MS : OPEN_MS);
    });
    item.addEventListener('mouseleave', () => {
      if (!canHover.matches) return;
      clearTimeout(timer);
      timer = setTimeout(() => { if (d.open && d.dataset.hover) setOpen(d, false); }, CLOSE_MS);
    });
    // A click on the label right after a hover opened it keeps the panel open (pinned) instead of closing it.
    d.querySelector('summary').addEventListener('click', (e) => {
      if (d.dataset.hover) { e.preventDefault(); delete d.dataset.hover; d.open = true; e.currentTarget.setAttribute('aria-expanded', 'true'); }
    });
  });
})();
